
function offcanvasToggle(action) {
    var mobileNavigation = $(".js-offcanvas-navigation");
    var mobileNavigationInner = $(".js-offcanvas-inner");

    if (action == "close") {
        console.log("close");
        mobileNavigation.css("width", 0);
    }

    if (action == "open") {
        mobileNavigationInner.show();
        mobileNavigation.css("width", "100%");
    }
}
 

$(document).ready(function () {
    
    $(".js-offcanvas-trigger").on("click", function () {
        offcanvasToggle("open"); 
    });
    $(".js-offcanvas-offset").on("click", function () {
        offcanvasToggle("close");
    });
    $(".js-offcanvas-close").on("click", function () {
        offcanvasToggle("close");
    });

    
    //fold out navigation
    $(".js-nav-fold-trigger").on("click", function (e) {
        var item = $(this).closest(".nav-fold-item");
        e.preventDefault();
        if (!item.hasClass("nav-fold-open")) {
            item.addClass("nav-fold-open").children(".nav-fold-children").slideDown();
        } else {
            item.removeClass("nav-fold-open").children(".nav-fold-children").slideUp();
        }
    });

    //navigation slide right MU: If dropdown/multilevel navigation is implemented, comment this back in.
    if ($(".nav-inpath").length > 0) {
        $(".js-nav-list").animate({
            left: "-=" + 100 * $(".nav-inpath").length + "%"
        });
    }
    $(".js-nav-next").on("click", function (e) {
        console.log("click");
        e.preventDefault();
        var $list = $(".js-nav-list");
        var $target = $(this).closest(".js-nav-item").children(".js-nav-child");
        console.log($target);
        $target.show(0, function () {
            $list.animate({
                left: "-=100%"
            });
        });
        return false;
    });
    $(".js-nav-previous").on("click", function () {
        var $list = $(".js-nav-list");
        var $target = $(this).closest(".js-nav-child");
        $list.animate({
            left: "+=100%"
        }, function () {
            $target.hide();
        });
    });


});